import React from 'react';
import { Box, Button, Heading, Stack, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import Container from '../ui/Container';
import heroImage from '../../img/wbann.webp';

export default function Hero() {
  return (
    <Box
      as="section"
      position="relative"
      minH={{ base: '520px', md: '560px', lg: '660px' }}
      display="flex"
      alignItems="center"
      // Reserva el hueco que ocupa la tarjeta de indicadores superpuesta,
      // para que no cubra los botones en pantallas pequeñas.
      pb={{ base: '72px', md: '80px', lg: 0 }}
      bgImage={`url(${heroImage})`}
      bgSize="cover"
      bgPosition="center"
      _before={{
        content: '""',
        position: 'absolute',
        inset: 0,
        bgGradient:
          'linear(to-r, rgba(6,26,51,0.92) 0%, rgba(6,26,51,0.72) 55%, rgba(6,26,51,0.45) 100%)',
      }}
    >
      <Container position="relative" zIndex={1}>
        <Stack maxW="640px" spacing={6} py={{ base: 12, lg: 0 }}>
          <Heading as="h1" size="h1" color="text.inverse">
            Soluciones eléctricas integrales para cada proyecto
          </Heading>
          <Text fontSize={{ base: 'md', lg: 'lg' }} color="whiteAlpha.900">
            Diseñamos, suministramos, instalamos y mantenemos sistemas
            eléctricos de baja y media tensión para la industria, el comercio y
            proyectos residenciales.
          </Text>
          <Stack direction={{ base: 'column', sm: 'row' }} spacing={4} pt={2}>
            <Button as={RouterLink} to="/contact?subject=quote" variant="primary" size="lg"
              w={{ base: 'full', sm: 'auto' }}>
              Solicitar cotización
            </Button>
            <Button as={RouterLink} to="/projects" variant="inverse" size="lg"
              w={{ base: 'full', sm: 'auto' }}>
              Ver proyectos
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
